/* 纸张底色：原文里到处硬编码的 #FAF9F5，这里收成一处的常量，
   方便和 CHART_THEME.paper 对照。 */

const STAGE_PAPER = "#FAF9F5";

export { STAGE_PAPER };
